<template>
    <div v-if="slides.length">
        <VueSlickCarousel
            :arrows="false"
            :dots="false"
            :adaptiveHeight="false"
            :autoplay="true"
            :autoplaySpeed="4000"
            class="announcement-ticker"
        >
            <div
                v-for="slide in slides"
                :key="slide.id"
                :style="{ backgroundColor: slide.color }"
            >
                {{ slide.desc }}
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "Ticker",
    components: { VueSlickCarousel },
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
